import companyService from "../../../services/http/company/company.service";
import { companyActionTypes } from "../../actionTypes/company/company.actionTypes";

export const resetCompany = () => async (dispatch) => {
  dispatch({ type: companyActionTypes.RESET_COMPANY });
};

export const getCompany = (companyId) => async (dispatch) => {
  let response;
  dispatch({ type: companyActionTypes.START_GET_COMPANY });
  try {
    response = await companyService.getCompany(companyId);

    dispatch({
      type: companyActionTypes.GET_COMPANY_SUCCESS,
      payload: response.data.payload, // assuming `response.data` contains the charge point info
    });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: companyActionTypes.GET_COMPANY_FAILURE,
      payload: error.message || "Failed to fetch company.",
    });
  }
  return response?.data;
};

export const companyActions = {
  resetCompany,
  getCompany,
};
